export default __webpack_public_path__ + "static/icon-dark-c41d8e943eeeda2e197935a34afaff162df19e6652cd33a302caf58bb8cd39cb.png";